// extracted by mini-css-extract-plugin
export default {"title":"uploadSpaceImages_title__yMwEX","wrapper":"uploadSpaceImages_wrapper__WHP8L"};